import { render } from "./absensi-peserta.vue?vue&type=template&id=5ee76e7e"
import script from "./absensi-peserta.vue?vue&type=script&lang=js"
export * from "./absensi-peserta.vue?vue&type=script&lang=js"

import "./absensi-peserta.vue?vue&type=style&index=0&id=5ee76e7e&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__